import { useAnalytics } from '../third-party-integration/amplitude';
import * as Styles from './styles';
import HistoryCard from './HistoryCard';
import {useTranslation} from 'react-i18next';
import { useTheme } from '../theme/useTheme';
import {useWebViewStore} from "../webview/useWebViewStore";
import { useSideSheetStore } from "../components/SideSheet/useSideSheetStore";
import { AMPLITUDE_EVENTS } from '../../constants';
import { useHistory } from "react-router-dom";
import { useMemo } from 'react';

export default function HistoryContent() {

  const { webviews, removeWebView ,removeAllWebView,setActiveWebView ,visualOrder} = useWebViewStore();
  const { closeSideSheet } = useSideSheetStore();
  const { trackEvent } = useAnalytics();
  const { t } = useTranslation();
  const { darkMode } = useTheme();
  const history = useHistory();

  const sortedWebviews = useMemo(() => {
    return [...webviews].sort((a, b) => {
      const indexA = visualOrder.indexOf(a.id);
      const indexB = visualOrder.indexOf(b.id);
      
      // Fallback if an ID hasn't been added to visualOrder yet
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
  }, [webviews, visualOrder]);

  const handleOpenClick = (pane: any) => {
    closeSideSheet();
    if(pane.type === 'application'){
      history.push(`/unify/aview/${pane.id}/N`);
    }else{
      history.push(`/unify/wview/${pane.appId}/${pane.id}/N`);
    }
    setActiveWebView(pane.id);
    trackEvent(AMPLITUDE_EVENTS.HISTORY_ITEM, { 'History Item': pane.name, 'Action': 'Open' });
  };

  const handleCloseClick = (paneId: string) => {
    removeWebView(paneId);
    history.push(`/unify/applications`);
    trackEvent(AMPLITUDE_EVENTS.HISTORY_ITEM, { 'History Item': paneId, 'Action': 'Close' });
  };

  const handleCloseAllClick = () => {
    removeAllWebView();
    history.push(`/unify/applications`);
    trackEvent(AMPLITUDE_EVENTS.HISTORY_ITEM, { 'Action': 'Close All' });
  };

  return (
    <Styles.HistoryContentWrapper data-testid="history-content">
      {webviews.length > 1 &&
      <Styles.CloseAllButtonContainer>
      <Styles.CloseAllButton data-testid="history-close-all"
            onClick={handleCloseAllClick}
            text={t('history.closeAll')}
            darkMode={darkMode}/>
        </Styles.CloseAllButtonContainer>}
      {sortedWebviews.map((pane:any) => (
        <HistoryCard
          key={pane.id}
          iconColor={pane.icon}
          iconText={pane.iconText}
          isActive={pane.active}
          name={pane.name}
          onCloseClick={() => handleCloseClick(pane.id)}
          onOpenClick={() => handleOpenClick(pane as any)}
        />
      ))}
    </Styles.HistoryContentWrapper>
  );
}
